import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProductOutlinedSvg from "@ant-design/icons-svg/es/asn/ProductOutlined";
import AntdIcon from '../components/AntdIcon';
var ProductOutlined = function ProductOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ProductOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ProductOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ProductOutlined';
}
export default RefIcon;